import { render, staticRenderFns } from "./dendropdownpage.vue?vue&type=template&id=09a14758&"
import script from "./dendropdownpage.vue?vue&type=script&lang=js&"
export * from "./dendropdownpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports